// Источник: https://javascript.plainenglish.io/how-to-find-the-caret-inside-a-contenteditable-element-955a5ad9bf81
export function getCaretIndex(element: any) {
  let position = 0
  const isSupported = typeof window.getSelection !== 'undefined'

  if (isSupported) {
    const selection = window.getSelection()

    if (selection && selection?.rangeCount !== 0) {
      const range = selection.getRangeAt(0)
      const preCaretRange = range.cloneRange()

      preCaretRange.selectNodeContents(element)
      preCaretRange.setEnd(range?.endContainer, range?.endOffset)
      position = preCaretRange.toString().length
    }
  }

  return position
}

// Источник: https://www.geeksforgeeks.org/how-to-set-cursor-position-in-content-editable-element-using-javascript/
export function setCaretIndex(element: any, index: number) {
  const isSupported = typeof window.getSelection !== 'undefined'

  if (isSupported) {
    const rangeObj = document.createRange()
    const selectedObj = window.getSelection()

    if (!selectedObj) {
      return
    }

    rangeObj.setStart(element.firstChild, 0)
    rangeObj.setEnd(element.firstChild, index)
    rangeObj.collapse()
    selectedObj.removeAllRanges()
    selectedObj.addRange(rangeObj)
  }
}
